import React, { useContext } from "react";
import { CustomTextField } from "../../../componentes/atoms/CustomTextField/CustomTextField";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";
import './styles/PartsInformation.css'

export default function PartsInformation({ data }) {
  const {
    selectedCountry,
  } = useContext(Context);

  const keys = Object.keys(language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.informacoesDaPeca.data);
  const remainingKeys = keys.slice(3);

  return (
    <>
      <div className="partsInformation-grid">
        {remainingKeys.map(key => (
          <CustomTextField
            key={key}
            className="partsInformation-card"
            InputProps={{
              readOnly: true,
            }}
            label={language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.informacoesDaPeca.data[key]}
            value={data?.[key] ?? ''}
          />
        ))}
      </div>
    </>
  );
}
